"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine whether the given objects are deeply equal.
 *
 * @Param {any} objA - The source object to compare.
 * @Param {any} objB - The object to compare against.
 *
 * @Example
 *
 *   isEqual({ a: 'a' }, { a: 'a' })
 *   //=> true
 *
 *   isEqual({ a: 'a' }, { a: 'b' })
 *   //=> false
 */
function isEqual(objA, objB) {
    return JSON.stringify(objA) === JSON.stringify(objB);
}
exports.isEqual = isEqual;
//# sourceMappingURL=is-equal.js.map